import { Col, Container, Row } from 'react-bootstrap';
import EcomNewCustomersCard from 'components/cards/EcomNewCustomersCard';
import EcomTopRegionsMap from 'components/leaflet-maps/EcomTopRegionsMap';
import EcomStats from 'components/stats/EcomStats';
import EcomProjectionVsActual from 'components/modules/e-commerce/dashboard/EcomProjectionVsActual';
import EcomReturningCustomerRate from 'components/modules/e-commerce/dashboard/EcomReturningCustomerRate';
import EcomTopRegions from 'components/modules/e-commerce/dashboard/EcomTopRegions';
import Section from 'components/base/Section';
import {
  DashboardData,
  getDashboard,
  OrderDataRegion,
  getOrderDataByRegion
} from 'api/dashboard/_request';
import { useQuery } from '@tanstack/react-query';
import EcomTotalOrders from '../../../components/modules/e-commerce/dashboard/EcomTotalOrders';
import EcomTotalProductCard from 'components/cards/EcomTotalProductCard';
import EcomTopBrandCard from 'components/cards/EcomTopBrandCard';
import EcomLatestAllReviewsTabs from 'components/tables/EcomLatestAllReviewsTabs';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { useEffect, useState } from 'react';
import EcomProductSpentsByOrder from 'components/cards/EcomProductSpentsByOrder';
import EcomProductReviews from 'components/modules/e-commerce/dashboard/EcomProductReviews';

const Ecommerce = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const { data: dashboardDatas } = useQuery<DashboardData>({
    queryKey: ['dashboard-data', id],
    queryFn: () => getDashboard(id)
  });

  const [orderRegionData, setOrderRegionData] = useState<OrderDataRegion[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getOrderDataByRegion(id);
        setOrderRegionData(data || []);
      } catch (error) {
        console.error('Failed to fetch product data:', error);
      }
    };
    fetchData();
  }, [id]);

  return (
    <>
      {/* <Section small> */}
      <Container className="px-xl-0 px-xxl-3 mt-2">
        <div className="pb-5">
          <Row className="g-4">
            <Col xs={12} xxl={5} className="h-100">
              <div className="mb-8">
                <h2 className="mb-2">Ecommerce Vendor Dashboard</h2>
                <h5 className="text-body-tertiary fw-semibold">
                  Here’s what’s going on at your business right now
                </h5>
              </div>
              <EcomStats
                weekOrderData={dashboardDatas?.weekorders ?? 0}
                totalOrders={dashboardDatas?.totalOrders ?? 0}
                products={dashboardDatas?.products ?? 0}
              />
            </Col>
          </Row>
          <Row className="g-4 align-items-stretch">
            <Col xs={12} md={8}>
              <div className="h-100 t-0 b-0 d-flex flex-column border rounded p-3">
                <EcomTotalOrders />
              </div>
            </Col>

            <Col xs={12} md={4}>
              <div className="d-flex flex-column h-auto">
                <div className="flex-fill mb-3">
                  <EcomTotalProductCard />
                </div>
                <div className="flex-fill">
                  <EcomNewCustomersCard />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="g-4 mt-3">
            <Col xs={12} md={6}>
              <div className="d-flex flex-column h-100">
                <EcomTopBrandCard />
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="d-flex flex-column h-100">
                <EcomProductSpentsByOrder />
              </div>
            </Col>
          </Row>
        </div>
        <div className=" px-4 px-lg-6 bg-body-emphasis pt-5 border-y">
          <EcomLatestAllReviewsTabs vendorId={id} />
          {/* <EcomLatestReviewsTable /> */}
        </div>
        <Row className="gx-6">
          <Col xs={12} xl={6}>
            <EcomTopRegions orderData={orderRegionData} />
          </Col>
          <Col xs={12} xl={6}>
            <div className=" ms-xl-0 h-100">
              <div className="h-100 w-100" style={{ minHeight: 300 }}>
                <EcomTopRegionsMap data={orderRegionData} />
              </div>
            </div>
          </Col>
        </Row>
        <div className=" px-4 px-lg-6 bg-body-emphasis pt-6 pb-9 border-top">
          <Row className="g-6">
            <Col xs={12} xl={6}>
              <EcomProductReviews vendorId={id} />
            </Col>
            <Col xs={12} xl={6}>
              <EcomReturningCustomerRate />
            </Col>
          </Row>
        </div>
      </Container>
      {/* </Section> */}
    </>
  );
};

export default Ecommerce;
